import axios from "./axios";
import store from "../store";

export default {
  async getCurrentUser() {
    const currentUser = await axios.getData(
      "/auth/user",
      localStorage.getItem("token")
    );
    store.commit("setCurrentUser", currentUser);
    return currentUser;
  },
  async setUserEmis(emis) {
    const data = await axios.postDataWithToken(
      "/auth/get-selected-school",
      { emis },
      localStorage.getItem("token")
    );

    if (data == "unauthorized") {
      return false;
    } else {
      store.commit("setUserSchool", data.school);
      store.commit("setThemeColor", data.school.primary_bg_color);
      store.commit("setSecondaryColor", data.school.secondary_bg_color);
      store.commit("setAppName", data.school.schname);
      store.commit("setSiteArticles", data.posts);
      store.commit("setSiteStats", data.stats);
      store.commit("setCurrentUser", data.user);
      store.dispatch("setUserStudents", {
        userId: data.user.id,
        token: localStorage.getItem("token"),
      });

      localStorage.setItem("themeColor", data.school.primary_bg_color);
      localStorage.setItem("secondaryColor", data.school.seondary_bg_color);
      localStorage.setItem("appName", data.school.schname);
      localStorage.setItem("userSchool", JSON.stringify(data.school));

      return true;
    }
  },
};
